import { render, staticRenderFns } from "./MethodPopup.vue?vue&type=template&id=1a22dfff"
import script from "./MethodPopup.vue?vue&type=script&lang=js"
export * from "./MethodPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports